import { useState, useEffect } from 'react';
import { useWeb3WithDefault } from './useWeb3WithDefault';
import useInterval from 'ahooks/lib/useInterval';
import { CHAIN_CONFIG } from '../config/bizConfig';

export const useGasPrice = () => {
    const [gasPrice, setGasPrice] = useState(0);
    const { web3, chainId } = useWeb3WithDefault();

    useInterval(() => {
        web3.eth.getGasPrice().then((v: any) => {
            // setGasPrice(v);
            // console.log('gas price: ', v);
            // 2.5 for priority fee
            const priorityFee = 0; //2.5;
            setGasPrice(Number(v) + priorityFee * 1e9);
        });
    }, CHAIN_CONFIG.AUTO_REFRESH_GAS_PRICE_INTERVAL);

    useEffect(() => {
        web3.eth.getGasPrice().then((v: any) => {
            // setGasPrice(v);
            // 2.5 for priority fee
            const priorityFee = 0; //2.5;
            setGasPrice(Number(v) + priorityFee * 1e9);
        });
    }, [web3, chainId]);

    return { gasPrice };
};
